import React from 'react';
import BaseList from 'components/lists/BaseList';

function formatLastTransmission(row) {
  const dt = row.lastTransmission && row.lastTransmission.datetime_utc;
  if (!dt || dt.length < 14) return '—';
  const utc = new Date(
    Date.UTC(
      parseInt(dt.substring(0, 4), 10),
      parseInt(dt.substring(4, 6), 10) - 1,
      parseInt(dt.substring(6, 8), 10),
      parseInt(dt.substring(8, 10), 10),
      parseInt(dt.substring(10, 12), 10),
      parseInt(dt.substring(12, 14), 10),
    ),
  );
  if (isNaN(utc.getTime())) return '—';
  return utc.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}

function ListLocks(props) {
  const { match } = props;
  return (
    <BaseList
      columns={[
        { value: row => row.unitnumber, label: 'Unit Number', sort: 'unitnumber' },
        { value: row => row.name, label: 'Nome', sort: 'name' },
        { value: row => (row.company && row.company.name) || '—', label: 'Empresa' },
        { value: row => row.vehiclemodel, label: 'Modelo', sort: 'vehiclemodel' },
        { value: row => row.active === '1' ? 'Ativo' : 'Inativo', label: 'Status' },
        { value: row => (row.equipments && row.equipments.length) || 0, label: 'Equipamentos' },
        { value: row => formatLastTransmission(row), label: 'Última Transmissão' },
      ]}
      genericSearchFields={[
        { label: 'Unit Number', name: 'unitnumber' },
        { label: 'Nome', name: 'name' },
      ]}
      basePath="lock"
      title="Lista de Cadeados"
    />
  );
}

export default ListLocks;
